
// import { useState } from "react";
// import {
//   getLifeStages,
//   getVisibleQuestions,
//   formatStageLabel,
//   getLifeStageDetail,
//   getLifeStageMeta,
// } from "../Reusablesteps/Resolvelifestage";
// import StepperProgress from "../Reusablesteps/Stepperprogress";
// import { BtnBack, BtnContinue } from "../Reusablecomponents/Button/Reusableutton";
// import content from './CareJourney.json';
// const T = {
//   purple700: "#3B1A8C",
//   purpleBtn: "#3D1A8A",
//   purpleLight: "#EDE9FB",
//   purpleTag: "#E8E3FA",
//   lavenderBg: "#F4F1FD",
//   heading: "#1A1033",
//   sub: "#6B7280",
//   muted: "#9CA3AF",
//   border: "#E5E7EB",
// };

// const RightCard = ({ children }) => (
//   <div style={{
//     background: "#fff", borderRadius: 14, padding: 14, border: `1px solid ${T.border}`,
//     display: "flex", flexDirection: "column", gap: 10,
//   }}>
//     {children}
//   </div>
// );

// const YesNoBtn = ({ label, active, onClick }) => (
//   <button onClick={onClick} style={{
//     padding: "6px 16px", borderRadius: 8, fontSize: 11,
//     fontWeight: active ? 700 : 400,
//     border: active ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
//     background: active ? T.purpleLight : "#fff",
//     color: active ? T.purple700 : "#6B7280",
//     cursor: "pointer", transition: "all 0.15s",
//   }}>
//     {label}
//   </button>
// );

// const FooterBar = ({ left, center, right }) => (
//   <div style={{
//     display: "flex", alignItems: "center", justifyContent: "space-between",
//     padding: "12px 0 0", marginTop: 10, borderTop: `1px solid ${T.border}`,
//   }}>
//     <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>{left}</div>
//     <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>{center}</div>
//     <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>{right}</div>
//   </div>
// );

// const FooterNote = ({ children }) => (
//   <p style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 10, color: T.muted, margin: 0 }}>
//     🔒 {children}
//   </p>
// );

// // function resolveStageInfo(profile = {}, initialValues = {}) {
// //   const stages =
// //     initialValues?.stages?.length > 0
// //       ? initialValues.stages
// //       : getLifeStages(profile?.age, profile?.marital);

// //   const primaryStage = stages[0] || "youngAdult";
// //   const stageDetail  = getLifeStageDetail(primaryStage) || {};
// //   const stageMeta    = getLifeStageMeta(primaryStage) || { emoji: "🌸", color: "#F4F1FD" };

// //   return { stages, stageMeta };
// // }

// function resolveStageInfo(profile = {}, initialValues = {}) {
//   const stages =
//     initialValues?.stages?.length > 0
//       ? initialValues.stages
//       : getLifeStages(
//         profile?.ageGroup || profile?.age,
//         profile?.marital || profile?.maritalStatus
//       );

//   const primaryStage = stages[0] || "youngAdult";
//   const stageDetail = getLifeStageDetail(primaryStage) || {};
//   const stageMeta = getLifeStageMeta(primaryStage) || { emoji: "🌸", color: "#F4F1FD" };

//   return { stages, stageMeta };
// }
// export default function BasicLifeStageScreen({ onNext, onBack, stepIndex, totalSteps, profile = {}, initialValues = {} }) {
//   const S = content?.screens?.basicLifeStage;

//   const [answers, setAnswers] = useState(initialValues || {});
//   const today = new Date().toISOString().split("T")[0];
//   const [lmp, setLmp] = useState(initialValues?.lmp || "");
//   const [deliveryDate, setDelivery] = useState(initialValues?.deliveryDate || "");

//   if (!S) {
//     console.error("basicLifeStage config missing from CareJourney.json");
//     return null;
//   }

//   const setAns = (key, val) => setAnswers(p => ({ ...p, [key]: val }));
//   const { stages, stageMeta } = resolveStageInfo(profile, initialValues);
//   console.log("resolveStageInfo →", { rawProfile: profile, resolvedStages: stages });

//   // ── Filter first, then assign sequential visible numbers ───────────────────
//   // const visibleQuestions = getVisibleQuestions(stages)
//   //   .filter(q => {
//   //     if (q.key === "trying_pregnant" && answers["currently_pregnant"] === "Yes") return false;
//   //      if (q.key === "last_delivery" && answers["delivered_recently"] !== "Yes") return false;
//   //     return true;
//   //   })
//   //   .map((q, idx) => ({ ...q, visibleNum: idx + 1 }));

//   const visibleQuestions = getVisibleQuestions(stages)
//   .filter(q => {
//     if (q.key === "trying_pregnant" && answers["currently_pregnant"] === "Yes") return false;
//     if (q.key === "last_delivery" && answers["delivered_recently"] !== "Yes") return false;
//     if (q.key === "currently_pregnant" && answers["periods_started"] !== "No") return false;
//     if (q.key === "lmp" && answers["periods_started"] !== "Yes") return false;
//     return true;
//   })
//   .map((q, idx) => ({ ...q, visibleNum: idx + 1 }));
//   return (
//     <>
//       {/* <PageWrap> */}
//       {/* Header */}
//       <div style={{ marginBottom: 10 }}>
//         <div className="scj-header">
//           <div>
//             <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>
//               {S.pageTitle}
//             </h1>
//             <p style={{ fontSize: 11, color: T.sub, margin: "0 0 8px" }}>
//               {S.pageSubtitle}
//             </p>
//           </div>
//           <StepperProgress current={stepIndex} total={totalSteps} />
//         </div>
//         <div style={{
//           display: "inline-flex", alignItems: "center", gap: 6,
//           background: stageMeta.color || T.purpleTag,
//           borderRadius: 20, padding: "3px 10px", fontSize: 10, fontWeight: 600, color: T.purple700,
//         }}>
//           {stageMeta.emoji} {stages.map(formatStageLabel).join(" · ")}
//         </div>
//       </div>

//       <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
//         <div style={{ flex: 1 }}>
//           <div style={{ background: "#fff", borderRadius: 12, padding: "4px 14px", border: `1px solid ${T.border}` }}>
//             {visibleQuestions.map((q, idx) => (
//               <div
//                 key={q.key}
//                 style={{
//                   display: "flex", alignItems: "center", gap: 10, padding: "10px 0",
//                   borderBottom: idx < visibleQuestions.length - 1 ? `1px solid ${T.border}` : "none",
//                 }}
//               >
//                 <div style={{
//                   width: 26, height: 26, background: T.purple700, borderRadius: "50%",
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                   fontSize: 10, fontWeight: 700, color: "#fff", flexShrink: 0,
//                 }}>
//                   {q.visibleNum}
//                 </div>

//                 <div style={{ flex: 1, minWidth: 0 }}>
//                   <p style={{ fontWeight: 600, fontSize: 11, color: T.heading, margin: 0 }}>{q.q}</p>
//                   <p style={{ fontSize: 10, color: T.muted, margin: 0 }}>{q.desc}</p>
//                 </div>

//                 {q.type === "yesno" && (
//                   <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
//                     <YesNoBtn label={S.yesNoOptions.yes} active={answers[q.key] === "Yes"} onClick={() => setAns(q.key, "Yes")} />
//                     <YesNoBtn label={S.yesNoOptions.no} active={answers[q.key] === "No"} onClick={() => setAns(q.key, "No")} />
//                   </div>
//                 )}

//                 {q.type === "date" && (
//                   <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
//                     <input
//                       type="date"
//                       max={today}
//                       value={q.key === "lmp" ? lmp : deliveryDate}
//                       onChange={e => q.key === "lmp" ? setLmp(e.target.value) : setDelivery(e.target.value)}
//                       style={{
//                         border: `1.5px solid ${T.border}`, borderRadius: 8,
//                         padding: "5px 10px", fontSize: 11, outline: "none", color: T.heading,
//                       }}
//                     />
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         <div style={{ width: 220, flexShrink: 0 }}>
//           <RightCard>
//             <div style={{ display: "flex", justifyContent: "center" }}>
//               <div style={{
//                 width: 80, height: 80, background: stageMeta.color || "#FFF0F3",
//                 borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center",
//                 fontSize: 48, userSelect: "none",
//               }}>
//                 {stageMeta.emoji}
//               </div>
//             </div>

//             <p style={{ fontWeight: 700, fontSize: 12, color: T.heading }}>{S.sideCard.title}</p>
//             <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>
//               {S.sideCard.description}
//             </p>

//             <div style={{ background: stageMeta.color || T.lavenderBg, borderRadius: 8, padding: "8px 10px" }}>
//               <p style={{ fontSize: 10, fontWeight: 600, color: T.heading, margin: "0 0 5px" }}>
//                 {S.sideCard.detectedStageLabel}
//               </p>
//               <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
//                 {stages.map(s => (
//                   <span key={s} style={{
//                     fontSize: 10, background: T.purpleTag, color: T.purple700,
//                     borderRadius: 20, padding: "2px 8px", fontWeight: 600,
//                   }}>
//                     {stageMeta.emoji} {formatStageLabel(s)}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </RightCard>
//         </div>
//       </div>

//       <FooterBar
//         left={<BtnBack variant="outline" onClick={onBack} />}
//         center={<FooterNote>{S.footerNote}</FooterNote>}
//         right={<BtnContinue onClick={() => onNext({ ...answers, lmp, deliveryDate, stages })} />}
//       />
//     </>
//   );
// }
import { useState } from "react";
import {
  getLifeStages,
  getVisibleQuestions,
  formatStageLabel,
  getLifeStageDetail,
  getLifeStageMeta,
} from "../Reusablesteps/Resolvelifestage";
import StepperProgress from "../Reusablesteps/Stepperprogress";
import { BtnBack, BtnContinue } from "../Reusablecomponents/Button/Reusableutton";
import content from './CareJourney.json';
const T = {
  purple700: "#3B1A8C",
  purpleBtn: "#3D1A8A",
  purpleLight: "#EDE9FB",
  purpleTag: "#E8E3FA",
  lavenderBg: "#F4F1FD",
  heading: "#1A1033",
  sub: "#6B7280",
  muted: "#9CA3AF",
  border: "#E5E7EB",
};

const RightCard = ({ children }) => (
  <div style={{
    background: "#fff", borderRadius: 14, padding: 14, border: `1px solid ${T.border}`,
    display: "flex", flexDirection: "column", gap: 10,
  }}>
    {children}
  </div>
);

const YesNoBtn = ({ label, active, onClick }) => (
  <button onClick={onClick} style={{
    padding: "6px 16px", borderRadius: 8, fontSize: 11,
    fontWeight: active ? 700 : 400,
    border: active ? `2px solid ${T.purple700}` : `1.5px solid ${T.border}`,
    background: active ? T.purpleLight : "#fff",
    color: active ? T.purple700 : "#6B7280",
    cursor: "pointer", transition: "all 0.15s",
  }}>
    {label}
  </button>
);

const FooterBar = ({ left, center, right }) => (
  <div style={{
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "12px 0 0", marginTop: 10, borderTop: `1px solid ${T.border}`,
  }}>
    <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>{left}</div>
    <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>{center}</div>
    <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>{right}</div>
  </div>
);

const FooterNote = ({ children }) => (
  <p style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 10, color: T.muted, margin: 0 }}>
    🔒 {children}
  </p>
);

function resolveStageInfo(profile = {}, initialValues = {}) {
  const stages =
    initialValues?.stages?.length > 0
      ? initialValues.stages
      : getLifeStages(
        profile?.ageGroup || profile?.age,
        profile?.marital || profile?.maritalStatus
      );

  const primaryStage = stages[0] || "youngAdult";
  const stageDetail = getLifeStageDetail(primaryStage) || {};
  const stageMeta = getLifeStageMeta(primaryStage) || { emoji: "🌸", color: "#F4F1FD" };

  return { stages, stageMeta };
}

export default function BasicLifeStageScreen({ onNext, careJourneyContent, onBack, stepIndex, totalSteps, profile = {}, initialValues = {} }) {
  const S = careJourneyContent?.screens?.basicLifeStage;

  const [answers, setAnswers] = useState(initialValues || {});
  const today = new Date().toISOString().split("T")[0];
  const [lmp, setLmp] = useState(initialValues?.lmp || "");
  const [deliveryDate, setDelivery] = useState(initialValues?.deliveryDate || "");

  if (!S) {
    console.error("basicLifeStage config missing from CareJourney.json");
    return null;
  }

  const setAns = (key, val) => setAnswers(p => ({ ...p, [key]: val }));
  const { stages, stageMeta } = resolveStageInfo(profile, initialValues);
  console.log("resolveStageInfo →", { rawProfile: profile, resolvedStages: stages });

  // ── Visibility (both stage-based AND answer-based) now lives entirely in
  //    CareJourney.json → screens.lifeStageQuestions, edited via the
  //    CareJourneyEditor dashboard. No more hardcoded key checks here —
  //    adding a question in the dashboard is enough; no code change needed.
  const visibleQuestions = getVisibleQuestions(stages, answers, careJourneyContent?.screens?.lifeStageQuestions || {});

  return (
    <>
      {/* Header */}
      <div style={{ marginBottom: 10 }}>
        <div className="scj-header">
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 700, color: T.heading, marginBottom: 4 }}>
              {S.pageTitle}
            </h1>
            <p style={{ fontSize: 11, color: T.sub, margin: "0 0 8px" }}>
              {S.pageSubtitle}
            </p>
          </div>
          <StepperProgress current={stepIndex} total={totalSteps} />
        </div>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: stageMeta.color || T.purpleTag,
          borderRadius: 20, padding: "3px 10px", fontSize: 10, fontWeight: 600, color: T.purple700,
        }}>
          {stageMeta.emoji} {stages.map(formatStageLabel).join(" · ")}
        </div>
      </div>

      <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
        <div style={{ flex: 1 }}>
          <div style={{ background: "#fff", borderRadius: 12, padding: "4px 14px", border: `1px solid ${T.border}` }}>
            {visibleQuestions.map((q, idx) => (
              <div
                key={q.key}
                style={{
                  display: "flex", alignItems: "center", gap: 10, padding: "10px 0",
                  borderBottom: idx < visibleQuestions.length - 1 ? `1px solid ${T.border}` : "none",
                }}
              >
                <div style={{
                  width: 26, height: 26, background: T.purple700, borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 10, fontWeight: 700, color: "#fff", flexShrink: 0,
                }}>
                  {q.visibleNum}
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontWeight: 600, fontSize: 11, color: T.heading, margin: 0 }}>{q.q}</p>
                  <p style={{ fontSize: 10, color: T.muted, margin: 0 }}>{q.desc}</p>
                </div>

                {q.type === "yesno" && (
                  <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                    <YesNoBtn label={S.yesNoOptions.yes} active={answers[q.key] === "Yes"} onClick={() => setAns(q.key, "Yes")} />
                    <YesNoBtn label={S.yesNoOptions.no} active={answers[q.key] === "No"} onClick={() => setAns(q.key, "No")} />
                  </div>
                )}

                {q.type === "date" && (
                  <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
                    <input
                      type="date"
                      max={today}
                      value={q.key === "lmp" ? lmp : deliveryDate}
                      onChange={e => q.key === "lmp" ? setLmp(e.target.value) : setDelivery(e.target.value)}
                      style={{
                        border: `1.5px solid ${T.border}`, borderRadius: 8,
                        padding: "5px 10px", fontSize: 11, outline: "none", color: T.heading,
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div style={{ width: 220, flexShrink: 0 }}>
          <RightCard>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{
                width: 80, height: 80, background: stageMeta.color || "#FFF0F3",
                borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 48, userSelect: "none",
              }}>
                {stageMeta.emoji}
              </div>
            </div>

            <p style={{ fontWeight: 700, fontSize: 12, color: T.heading }}>{S.sideCard.title}</p>
            <p style={{ fontSize: 10, color: T.sub, lineHeight: 1.5, margin: 0 }}>
              {S.sideCard.description}
            </p>

            <div style={{ background: stageMeta.color || T.lavenderBg, borderRadius: 8, padding: "8px 10px" }}>
              <p style={{ fontSize: 10, fontWeight: 600, color: T.heading, margin: "0 0 5px" }}>
                {S.sideCard.detectedStageLabel}
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {stages.map(s => (
                  <span key={s} style={{
                    fontSize: 10, background: T.purpleTag, color: T.purple700,
                    borderRadius: 20, padding: "2px 8px", fontWeight: 600,
                  }}>
                    {stageMeta.emoji} {formatStageLabel(s)}
                  </span>
                ))}
              </div>
            </div>
          </RightCard>
        </div>
      </div>

      <FooterBar
        left={<BtnBack variant="outline" onClick={onBack} />}
        center={<FooterNote>{S.footerNote}</FooterNote>}
        right={<BtnContinue onClick={() => onNext({ ...answers, lmp, deliveryDate, stages })} />}
      />
    </>
  );
}